export default __webpack_public_path__ + "static/media/afternoon-audio.2335882c.mp3";